var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "t-toc",
    attrs: {
      "aria-label": _vm.level === 0 && 'Table of Contents',
      "role": _vm.level ? 'group' : 'tree'
    }
  }, [_vm.open ? _vm._l(_vm.model, function (entry) {
    return _c('TocEntry', {
      key: entry['entry-id'],
      attrs: {
        "entry": entry,
        "level": _vm.level
      }
    });
  }) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }